<button class="re-bet-button" ds-button kind="primary" variant="filled" size="large" truncate="true" [class.open]="isOpenTab" (click)="onClick()">
    {{ title }}
    <span slot="subtext" *ngIf="subTitleEnabled" [innerHTML]="subTitle"></span>
</button>
